import React, { useState } from 'react';
import { PracticePin } from './PracticePin';
import { DentalPractice } from '../../types';
import { ZoomIn, ZoomOut, Maximize2 } from 'lucide-react';
const mockPractices: DentalPractice[] = [
// Nord
{
  id: 'n1',
  name: 'Zahnzentrum Hamburg Hafen',
  address: 'Am Sandtorkai 48',
  city: '20457 Hamburg',
  phone: '040 1234567',
  email: 'info@zz-hamburg.de',
  employees: 12,
  territory: 'Nord',
  coordinates: {
    x: 53,
    y: 35
  }
}, {
  id: 'n2',
  name: 'Praxis Dr. Norden',
  address: 'Holstenstraße 1',
  city: '24103 Kiel',
  phone: '0431 987654',
  email: 'praxis@dr-norden.de',
  employees: 5,
  territory: 'Nord',
  coordinates: {
    x: 53,
    y: 28
  }
}, {
  id: 'n3',
  name: 'Dental Care Bremen',
  address: 'Obernstraße 45',
  city: '28195 Bremen',
  phone: '0421 555666',
  email: 'kontakt@dental-bremen.de',
  employees: 8,
  territory: 'Nord',
  coordinates: {
    x: 45,
    y: 42
  }
}, {
  id: 'n4',
  name: 'Zahnärzte am Maschsee',
  address: 'Arthur-Menge-Ufer 5',
  city: '30169 Hannover',
  phone: '0511 333444',
  email: 'team@maschsee-zahn.de',
  employees: 15,
  territory: 'Nord',
  coordinates: {
    x: 50,
    y: 48
  }
},
// Mitte
{
  id: 'm1',
  name: 'Main Tower Dentists',
  address: 'Neue Mainzer Str. 52',
  city: '60311 Frankfurt',
  phone: '069 998877',
  email: 'reception@main-dentists.de',
  employees: 22,
  territory: 'Mitte',
  coordinates: {
    x: 45,
    y: 70
  }
}, {
  id: 'm2',
  name: 'Praxis am Herkules',
  address: 'Wilhelmshöher Allee 2',
  city: '34117 Kassel',
  phone: '0561 112233',
  email: 'info@herkules-zahn.de',
  employees: 6,
  territory: 'Mitte',
  coordinates: {
    x: 50,
    y: 62
  }
}, {
  id: 'm3',
  name: 'Zahnmedizin Erfurt',
  address: 'Anger 12',
  city: '99084 Erfurt',
  phone: '0361 445566',
  email: 'kontakt@zahn-erfurt.de',
  employees: 9,
  territory: 'Mitte',
  coordinates: {
    x: 58,
    y: 65
  }
}, {
  id: 'm4',
  name: 'Leipzig Smile',
  address: 'Petersstraße 36',
  city: '04109 Leipzig',
  phone: '0341 778899',
  email: 'smile@leipzig-dent.de',
  employees: 14,
  territory: 'Mitte',
  coordinates: {
    x: 62,
    y: 58
  }
}, {
  id: 'm5',
  name: 'Ruhrpott Zähne',
  address: 'Kettwiger Str. 22',
  city: '45127 Essen',
  phone: '0201 223344',
  email: 'glueckauf@ruhr-zahn.de',
  employees: 18,
  territory: 'Mitte',
  coordinates: {
    x: 32,
    y: 58
  }
},
// Süd
{
  id: 's1',
  name: 'Zahnklinik Isartor',
  address: 'Tal 44',
  city: '80331 München',
  phone: '089 112233',
  email: 'info@isartor-klinik.de',
  employees: 35,
  territory: 'Süd',
  coordinates: {
    x: 55,
    y: 92
  }
}, {
  id: 's2',
  name: 'Praxis Schlossplatz',
  address: 'Königstraße 1',
  city: '70173 Stuttgart',
  phone: '0711 998877',
  email: 'team@schlossplatz-zahn.de',
  employees: 10,
  territory: 'Süd',
  coordinates: {
    x: 45,
    y: 82
  }
}, {
  id: 's3',
  name: 'Franken Dental',
  address: 'Königstraße 55',
  city: '90402 Nürnberg',
  phone: '0911 445566',
  email: 'servus@franken-dental.de',
  employees: 7,
  territory: 'Süd',
  coordinates: {
    x: 55,
    y: 80
  }
}, {
  id: 's4',
  name: 'Schwarzwald Lächeln',
  address: 'Kaiser-Joseph-Straße 200',
  city: '79098 Freiburg',
  phone: '0761 223344',
  email: 'info@freiburg-zahn.de',
  employees: 5,
  territory: 'Süd',
  coordinates: {
    x: 38,
    y: 90
  }
}];
export function TerritoryMap() {
  const [zoom, setZoom] = useState(100);
  const handleZoomIn = () => {
    setZoom(prev => Math.min(prev + 20, 200));
  };
  const handleZoomOut = () => {
    setZoom(prev => Math.max(prev - 20, 60));
  };
  const handleResetZoom = () => {
    setZoom(100);
  };
  return <div className="relative w-full h-[600px] bg-slate-50 rounded-xl overflow-hidden border border-slate-200" data-id="element-114">
      {/* Legend */}
      <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm p-4 rounded-lg shadow-sm border border-slate-200 z-20" data-id="element-115">
        <h4 className="text-xs font-semibold text-slate-500 uppercase mb-3" data-id="element-116">
          Vertriebsgebiete
        </h4>
        <div className="space-y-2" data-id="element-117">
          <div className="flex items-center gap-2" data-id="element-118">
            <div className="w-3 h-3 rounded-full bg-blue-500" data-id="element-119"></div>
            <span className="text-sm font-medium text-slate-700" data-id="element-120">Nord</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-121">
            <div className="w-3 h-3 rounded-full bg-teal-500" data-id="element-122"></div>
            <span className="text-sm font-medium text-slate-700" data-id="element-123">Mitte</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-124">
            <div className="w-3 h-3 rounded-full bg-amber-500" data-id="element-125"></div>
            <span className="text-sm font-medium text-slate-700" data-id="element-126">Süd</span>
          </div>
        </div>
      </div>

      {/* Zoom Controls */}
      <div className="absolute bottom-4 right-4 bg-white/90 backdrop-blur-sm rounded-lg shadow-sm border border-slate-200 z-20 flex flex-col gap-1 p-2" data-id="element-127">
        <button onClick={handleZoomIn} disabled={zoom >= 200} className="p-2 hover:bg-slate-100 rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed" title="Vergrößern" data-id="element-128">
          <ZoomIn className="h-5 w-5 text-slate-700" data-id="element-129" />
        </button>
        <button onClick={handleResetZoom} className="p-2 hover:bg-slate-100 rounded transition-colors" title="Zurücksetzen" data-id="element-130">
          <Maximize2 className="h-5 w-5 text-slate-700" data-id="element-131" />
        </button>
        <button onClick={handleZoomOut} disabled={zoom <= 60} className="p-2 hover:bg-slate-100 rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed" title="Verkleinern" data-id="element-132">
          <ZoomOut className="h-5 w-5 text-slate-700" data-id="element-133" />
        </button>
        <div className="text-xs text-center text-slate-600 font-medium mt-1 px-1" data-id="element-134">
          {zoom}%
        </div>
      </div>

      {/* Map Container */}
      <div className="w-full h-full overflow-auto p-4 md:p-8" data-id="element-135">
        <div className="relative w-full min-w-[800px] h-[900px] mx-auto transition-transform duration-300 ease-out" style={{
        transform: `scale(${zoom / 100})`,
        transformOrigin: 'top center'
      }} data-id="element-136">
          {/* Germany Map Image Background */}
          <img src="https://cdn.magicpatterns.com/uploads/ehucuJfxWnNVpH3o2qYEKf/Karte_Deutschland.svg.png" alt="Karte von Deutschland mit Bundesländern" className="w-full h-full object-contain drop-shadow-xl" data-id="element-137" />

          {/* Pins Layer */}
          <div className="absolute inset-0" data-id="element-138">
            {mockPractices.map(practice => <PracticePin key={practice.id} practice={practice} data-id="element-139" />)}
          </div>
        </div>
      </div>
    </div>;
}